export const mobileActionIconProps = {
  variant: 'transparent' as const,
  w: 20,
  h: 20,
  miw: 20,
  mih: 20,
  bd: 'none',
}

export const desktopActionIconProps = {
  size: '24px',
  variant: 'subtle' as const,
  color: 'chatbox-secondary',
}
